import { GenericSearchFormProps } from '../../Shared/Components/SearchFormWrapper';
import { BookingBase } from '../../Shared/Types/bookingTypes';
import { IdNameDto } from '../../Shared/Types/common';
import {
  BookingSearchFiltersV2,
  defaultBookingSearchFiltersV2,
} from './bookingSearchTypes';

export interface AutomaticBookings extends BookingBase {
  startDate: string;
  durationInDays: number;
  offsetDays: number;
  numberOfBookings: number;
}

export type BookingSearchFilters = BookingSearchFiltersV2;

export const defaultBookingSearchFilters: BookingSearchFilters = defaultBookingSearchFiltersV2;

export type BookingSearchFormProps = GenericSearchFormProps<BookingSearchFilters>;

export interface BookingReturnContext {
  pathname: string;
  label?: string;
  filters?: BookingSearchFilters;
  page?: number;
  rowsPerPage?: number;
}

export interface BookingNavigationState {
  returnContext?: BookingReturnContext;
  restoredFilters?: BookingSearchFilters;
  restoredPage?: number;
  restoredRowsPerPage?: number;
}

export interface BookingFilterSelectDataDto {
  offers: IdNameDto[];
  companies: IdNameDto[];
  publishedOptions: IdNameDto[];
}
export interface BookingListRequest {
  offerId?: number;
  published?: boolean;
  startDateFrom?: string;
  startDateTo?: string;
  numberOfParticipants?: number;
  companyId?: number;
  applicant?: string;
  participant?: string;
  city?: string;
  includeCancelled?: boolean;
  pageNumber?: number;
  pageSize?: number;
}
